import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import { toReasonsJustificationData } from './adapters'
import type { ReasonsJustificationApi, ReasonsJustificationResponseData } from './types'

export const getReasonsJustification = async (): Promise<ReasonsJustificationResponseData> => {
  const response = await api.get<ReasonsJustificationApi[]>(
    endpoints.manageOv.getReasonsJustification,
  )

  return toReasonsJustificationData(response.data)
}
